exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table td.bg-green-light[data-v-4c3d9488]{background:#ccd3cf!important}.table td.bg-danger-light[data-v-4c3d9488]{background:#ffb1b1!important}.results-on-chart[data-v-4c3d9488]{width:100%}.small-label[data-v-4c3d9488]{font-size:12px;line-height:13px;margin-bottom:10px;margin-top:-4px;max-width:190px}", ""]);

// exports
